






































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwTransitionExpand } from '@libs-uuif/shared/sw-transition';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import DevicePickerHierarchy from './device-picker-hierarchy.vue';
import { Mutation, State } from 'vuex-class';
import {
  ItemSelectRequestData,
  ItemExpandRequestData,
} from '@libs-uuif/shared/sw-tree-list';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { DeviceHierarchy } from '@/shared/types/device-hierarchy.types';
import { CoreStoreState, SetDevicePickerVisiblePayload } from '@/core';
import { RootStoreState } from '@/store';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import _cloneDeep from 'lodash/cloneDeep';
import _debounce from 'lodash/debounce';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';

const cssPrefix = 'device-picker-slide';

@Component({
  components: {
    SwTransitionExpand,
    SwScrollView,
    DevicePickerHierarchy,
    SwTextfield,
    SwIconButton,
  },
  directives: {
    tooltip,
  },
})
export default class DevicePickerSlide extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required: true })
  visible: boolean;
  pageNumber: number = 0;

  @State(
    (state: RootStoreState) => state.CoreStoreModule.devicePickerSlideVisible,
  )
  readonly devicePickerSlideVisible: CoreStoreState['devicePickerSlideVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.deviceHierarchy)
  readonly deviceHierarchy: CoreStoreState['deviceHierarchy'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantList)
  readonly tenantList: CoreStoreState['tenantList'];

  @Mutation
  setDevicePickerSlideVisible: VuexMappedMutation<
    SetDevicePickerVisiblePayload
  >;

  expandedHierarchyItemIds: string[] = [];
  deviceHerarchySearchString: string = '';
  debouncedSearchString: string = '';
  deviceHierarchyTreeData: DeviceHierarchy[] = [];

  pageSize: number = 50;
  infiniteData: DeviceHierarchy[] = [];

  @Watch('devicePickerSlideVisible')
  onDevicePickerOpenStateChange() {
    if (this.devicePickerSlideVisible) {
      this.$nextTick(() => {
        const searchBox = this.$refs.deviceSearch as SwTextfield;
        if (!searchBox) {
          return;
        }
        searchBox.focus();
      });
    }
  }

  @Watch('deviceHierarchy')
  onHierarchyUpdate() {
    this.deviceHierarchyTreeData = _cloneDeep(this.deviceHierarchy);
    this.infiniteData = [];
    this.pageNumber = 0;
    this.pushItemsToView(0);
  }

  @Watch('deviceHerarchySearchString')
  private onSearchStringChange() {
    this.debouncedSetSearchString();
  }

  get debouncedSetSearchString() {
    return _debounce(() => {
      this.debouncedSearchString = this.deviceHerarchySearchString;
    },               300);
  }

  get effectiveHierarchyData() {
    if (!this.debouncedSearchString) {
      return this.infiniteData;
    }
    return this.searchHierarchy();
  }

  searchHierarchy(): DeviceHierarchy[] {
    const stack: DeviceHierarchy[] = [];
    const visited: any = { $: false };
    const result: DeviceHierarchy[] = [];
    const searchStr: string = this.deviceHerarchySearchString.toLocaleLowerCase();
    this.deviceHierarchyTreeData.map((nodeItem) => {
      stack.push(nodeItem);
      while (stack.length !== 0) {
        const node: DeviceHierarchy = stack.pop() as DeviceHierarchy;
        if (visited[node.id] === undefined || visited[node.id] === false) {
          visited[node.id] = true;
        }
        if (
          String(node.label)
            .toLocaleLowerCase()
            .includes(searchStr) &&
          visited[node.id]
        ) {
          result.push(node);
        }
        node.children.map((child) => {
          stack.push(child);
        });
      }
    });
    return result;
  }

  get selectedDeviceHierarchyNodeIds(): string[] {
    const ids: string[] = [];
    return ids;
  }

  private onRequestSelect(data: ItemSelectRequestData) {
    const selectedTenantIndex = this.tenantList.findIndex((entry) => {
      return entry.name === data.itemId;
    });
    if (selectedTenantIndex !== -1) {
      this.$store.commit('setTenantName', data.itemId);
      this.$store.commit('setTenant', `${this.tenantList[selectedTenantIndex].productGroupID}`);
    }
  }

  private onRequestExpand(data: ItemExpandRequestData) {
    if (
      data.expanding &&
      !this.expandedHierarchyItemIds.includes(data.itemId)
    ) {
      this.expandedHierarchyItemIds.push(data.itemId);
    } else if (!data.expanding) {
      const index = this.expandedHierarchyItemIds.indexOf(data.itemId);
      if (index >= 0) {
        this.expandedHierarchyItemIds.splice(index, 1);
      }
    }
  }

  private getInitialDeviceNodeHierarchy(
    hierarchyItem: DeviceHierarchy,
  ): DeviceHierarchy | null {
    for (const item of hierarchyItem.children) {
      if (item.type === 'device') {
        return item;
      }
      if (item.children && item.children.length > 0) {
        const r = this.getInitialDeviceNodeHierarchy(item);
        if (r) {
          return r;
        }
      }
    }
    return null;
  }

  private onCloseDeviceSlider() {
    this.setDevicePickerSlideVisible({ visible: false });
  }

  private mounted() {
    this.onHierarchyUpdate();
  }
  private onItemsScrolled(event: any) {// tslint:disable-line
    this.pushItemsToView(this.infiniteData.length, 50);
  }

  pushItemsToView(start: number, size: number = 50) {
    if (size <= 0) {
      return;
    }
    if (this.infiniteData.length < this.deviceHierarchyTreeData.length) {
      let count = 0;
      for (
        ;
        count < size && start + count < this.deviceHierarchyTreeData.length;
        count += 1
      ) {
        this.infiniteData.push(this.deviceHierarchyTreeData[start + count]);
      }
    }
  }
  bottomOftheWindow(
    scrollTop: number,
    clientHeight: number,
    scrollHeight: number,
  ) {
    return scrollTop + clientHeight === scrollHeight;
  }
}
